/**
 * Test conversations, keyed by the lead's Zoho record ID — the same ID the real feed
 * (Twilio SMS + calls, Zoho Mail) will be logged against, so a lead always finds its own thread.
 *
 * channel: 'sms' | 'email' | 'call'   direction: 'in' (from customer) | 'out' (from CIE)
 */
const mockCommunications = {
  // John Smith
  '8059800000061700': [
    { id: 'js1', channel: 'sms', direction: 'out', at: '2026-10-09T15:02:00-04:00',
      body: 'Hi John, this is Canadian Insulation Experts. Your free attic inspection is booked for Tue Oct 13, 10:00 AM – 12:00 PM. Reply YES to confirm.' },
    { id: 'js2', channel: 'sms', direction: 'in', at: '2026-10-09T15:20:00-04:00', body: 'YES' },
    { id: 'js3', channel: 'email', direction: 'out', at: '2026-10-09T15:21:00-04:00',
      subject: 'Your attic inspection is confirmed',
      body: 'Hi John,\n\nThanks for booking. Ibrahim will be at 123 Main Street on Tuesday, October 13 between 10:00 AM and 12:00 PM.\n\nThe inspection takes about 45 minutes and you’ll get your report the same day.\n\n— Canadian Insulation Experts' },
    { id: 'js4', channel: 'call', direction: 'in', at: '2026-10-12T09:41:00-04:00', durationSec: 132 },
    { id: 'js5', channel: 'sms', direction: 'in', at: '2026-10-12T09:47:00-04:00',
      body: 'Just called — can the tech park on the street? Side gate code is 4412.' },
  ],

  // Maria Garcia
  '8059800000073746690': [
    { id: 'mg1', channel: 'sms', direction: 'out', at: '2026-10-08T11:10:00-04:00',
      body: 'Hi Maria, your attic inspection with Canadian Insulation Experts is booked for Tue Oct 13, 11:00 AM – 1:00 PM. Reply YES to confirm.' },
    { id: 'mg2', channel: 'sms', direction: 'in', at: '2026-10-08T12:02:00-04:00', body: 'Yes confirmed, thank you!' },
    { id: 'mg3', channel: 'sms', direction: 'out', at: '2026-10-12T08:00:00-04:00',
      body: 'Good morning Maria! Reminder: Ibrahim arrives tomorrow between 11:00 AM and 1:00 PM.' },
  ],

  // Muhammad Khan — cancelled
  '8059800000073826781': [
    { id: 'mk1', channel: 'sms', direction: 'out', at: '2026-10-07T14:30:00-04:00',
      body: 'Hi Muhammad, your attic inspection is booked for Tue Oct 13, 12:00 – 2:00 PM. Reply YES to confirm.' },
    { id: 'mk2', channel: 'call', direction: 'out', at: '2026-10-11T16:05:00-04:00', durationSec: 0 },
    { id: 'mk3', channel: 'sms', direction: 'in', at: '2026-10-11T18:22:00-04:00',
      body: 'Sorry, need to cancel for now. Will reach out when we’re ready.' },
  ],

  // Sarah Johnson — rescheduled
  '8059800000074179020': [
    { id: 'sj1', channel: 'call', direction: 'out', at: '2026-10-10T13:12:00-04:00', durationSec: 254 },
    { id: 'sj2', channel: 'email', direction: 'out', at: '2026-10-10T13:20:00-04:00',
      subject: 'Your new inspection time',
      body: 'Hi Sarah,\n\nAs discussed on the phone, we’ve moved your attic inspection. We’ll text you the confirmed time shortly.\n\n— Canadian Insulation Experts' },
    { id: 'sj3', channel: 'sms', direction: 'in', at: '2026-10-12T10:15:00-04:00',
      body: 'Any afternoon next week works for me.' },
  ],

  // David Lee
  '8059800000074181003': [
    { id: 'dl1', channel: 'sms', direction: 'out', at: '2026-10-06T10:00:00-04:00',
      body: 'Hi David, your attic inspection with Canadian Insulation Experts is booked for Tue Oct 13, 3:00 – 5:00 PM. Reply YES to confirm.' },
    { id: 'dl2', channel: 'sms', direction: 'in', at: '2026-10-06T10:04:00-04:00', body: 'Confirmed' },
  ],
};

// leads with unread messages from the customer (cleared when the thread is opened)
export const initiallyUnread = ['8059800000061700', '8059800000074179020', '8059800000073826781'];

export default mockCommunications;
